import { render } from "./a-banners.vue?vue&type=template&id=4a0e0c40&scoped=true"
import script from "./a-banners.vue?vue&type=script&lang=js"
export * from "./a-banners.vue?vue&type=script&lang=js"

import "./a-banners.vue?vue&type=style&index=0&id=4a0e0c40&lang=sass&scoped=true"

import exportComponent from "/opt/bitnami/apps/ocmsta/subdomains/academy/htdocs/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a0e0c40"]])

export default __exports__